var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasContentHeader
        ? _c("page-content-header", { attrs: { item: _vm.item } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "content-section" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("page-content-creator", {
                        attrs: { itemid: _vm.itemid, pos: "top" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _vm.itemid
                        ? _c("node-element-local-tasks", {
                            attrs: { itemid: _vm.itemid },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notpublished
                        ? _c("div", { staticClass: "messages warning" }, [
                            _vm._v("Not published"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.itemid
                        ? _c("page-content-wysiwg-content", {
                            attrs: { item: _vm.item },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "page-content-type-page_content_group node-type-page_content_group",
                        },
                        [
                          _vm.itemid
                            ? _c(
                                "div",
                                { staticClass: "page-content-group" },
                                _vm._l(_vm.list, function (groupitem, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key,
                                      class: `content-multigroup-wrapper content-multigroup-${key} content-multigroup-delta-${key} content-multigroup-${_vm.specialRowClass(
                                        key
                                      )}`,
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "teaser-list-item",
                                          class: `field-item ${_vm.specialRowClass(
                                            key
                                          )}`,
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "teaser",
                                              class: _vm.alignorient,
                                            },
                                            [
                                              _c("content-group-image", {
                                                attrs: {
                                                  groupitem: groupitem,
                                                  orientation: _vm.orient,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("content-group-details", {
                                                attrs: { groupitem: groupitem },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("page-content-creator", {
                        attrs: { itemid: _vm.itemid, pos: "bottom" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }